/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { schema3OtherCreateIntentApiV1SandboxGithubOauthIntentsPost } from "../../funcs/schema3OtherCreateIntentApiV1SandboxGithubOauthIntentsPost.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .CreateIntentApiV1SandboxGithubOauthIntentsPostRequest$inboundSchema,
};

export const tool$schema3OtherCreateIntentApiV1SandboxGithubOauthIntentsPost:
  ToolDefinition<typeof args> = {
    name:
      "schema-3-other-create-intent-api-v1-sandbox-github-oauth-intents-post",
    description: `Create Intent`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await schema3OtherCreateIntentApiV1SandboxGithubOauthIntentsPost(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
